<div class="discounts-container">
  @if (showUnratedWarning ) {
    <nwx-notification-bubble class="unrated">
      Discounts will be available once the submission has been rated.
    </nwx-notification-bubble>
    <div class="unrated-spacer"></div>
  } @else {
    @for (product of products; track product.type) {
      <div class="discount-block">
        @if (product.name !== 'PersonalUmbrella') {
          <nwx-discounts-list
            [discounts]="findDiscountsForProduct(product.type)"
            [product]="product"
            [header]="product.name + ' policy discounts'"
            [maxSizeXSmall]="maxSizeXSmall$ | async"
          ></nwx-discounts-list>
        }
      </div>
    }
    @if (hasMultiProductDiscounts) {
      <div class="discount-block">
        <nwx-discounts-list
          [discounts]="findMultiProductDiscounts()"
          [header]="'Additional discounts'"
          [maxSizeXSmall]="maxSizeXSmall$ | async"
        ></nwx-discounts-list>
      </div>
    }
  }
  <ng-container>
    <div class="help-section">
      <bolt-icon name="question-circle" color="mediumBlue"></bolt-icon>
      <a
        class="help-content bolt-body-copy-sm"
        href="javascript:void(0)"
        (click)="openDiscountInfoModal()"
        >Information on all available discounts</a
        >
      </div>
    </ng-container>
  </div>
